webpackJsonp([12],{

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(857)
}
var Component = __webpack_require__(184)(
  /* script */
  __webpack_require__(862),
  /* template */
  __webpack_require__(863),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 498:
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.detectUa = function () {
    var browers = {};
    var ua = navigator.userAgent.toLowerCase();
    browers.iPad = ua.match(/ipad/);
    browers.iPhone = ua.match(/iphone/);
    browers.isAndroid = ua.match(/android/);
    browers.isiOS = ua.match(/ipad|iphone|ios/);
    browers.isDesktop = !browers.isiOS && !browers.isAndroid;
    browers.ie = ua.match(/iemobile/);
    browers.isWifi = ua.match(/nettype\/wifi|technology\/wifi/);
    browers.force_ssl = ua.match(/Android (5|6)/i);
    browers.is_ios_6 = ua.match(/iOS 6/i);
    browers.is_liveapp = ua.match(/LiveApp/i);
    return browers;
};

exports.jumpUrl = function (is_apk) {
    ga('send', 'event', 'app', 'download', location.pathname, 1);
    var isiOS = navigator.userAgent.match('iPad') || navigator.userAgent.match('iPhone') || navigator.userAgent.match('iPod'),
        isAndroid = navigator.userAgent.match('Android'),
        isDesktop = !isiOS && !isAndroid;
    function getCookie(name) {
        var arr,
            reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        if (arr = document.cookie.match(reg)) {
            return unescape(arr[2]);
        } else {
            return null;
        }
    }
    function jumpDownload(android_url, ios_url) {
        if (isAndroid) {
            location.href = android_url;
        } else if (isiOS) {
            location.href = ios_url;
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }

    function jumpDownloadCom(android_url, ios_url) {
        if (isAndroid) {
            var apk = location.href = '/download';
            var google_play = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
            adroidDownload(apk, google_play);
        } else if (isiOS) {
            location.href = 'https://go.onelink.me/app/ff33e3d5';
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }

    function jumpDownloadPopup() {
        if (isAndroid) {
            return '/download';
        } else if (isiOS) {
            return 'https://go.onelink.me/1751978436?pid=M_FB';
        } else if (isDesktop) {
            return 'http://www.allfootballapp.com/home';
        }
    }

    function adroidDownload(apk, google_play) {
        console.log('随机方法');
        if (Math.random() >= 0.5) {
            location.href = apk;
        } else {
            location.href = google_play;
        }
    }
    var goog_snippet_vars = function goog_snippet_vars() {
        var w = window;
        w.google_conversion_id = 838643918;
        w.google_conversion_label = 'ds1fCN_xrHkQzuHyjwM';
        w.google_remarketing_only = false;
    };

    function goog_report_conversion(url) {
        var isOperaMini = navigator.userAgent.indexOf('Opera Mini');
        console.log('isOperaMini', isOperaMini);
        goog_snippet_vars();
        window.google_conversion_format = '3';
        var opt = new Object();
        opt.onload_callback = function () {
            if (typeof url !== 'undefined') {
                console.log('url2', url);
                if (isAndroid) {
                    window.location = 'market://details?id=com.allfootball.news';
                    setTimeout(function () {
                        console.log('跳转GP失败');
                        window.location = url;
                    }, 1000);
                    return;
                }
                window.location = url;
            }
        };
        var conv_handler = window['google_trackConversion'];
        if (typeof conv_handler === 'function') {
            if (isOperaMini >= 0) {
                console.log('url', url);
                window.location = url;
            } else {
                conv_handler(opt);
            }
        }
    }
    var utm_source = getCookie('utm_source');
    var utm_campaign = getCookie('utm_campaign');
    var search = (location.search || '').slice(1);
    if (utm_source === 'google_search' && utm_campaign === 'EPL') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'La Liga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Bundesliga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Serie A') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Transfers') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'UC-Browser' && utm_campaign === 'p20') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (location.pathname === '/downloadCoin' || search.indexOf('utm_source=shareForAFCoin') > -1 || utm_source === 'shareForAFCoin') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else {
        if (is_apk) {
            if (location.hostname === 'm.all.football') {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-368.apk');
            } else {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-368.apk');
            }
        } else {
            var url = jumpDownloadPopup();
            console.log('ios的url', url);
            location.href = url;
            goog_report_conversion(url);
        }
    }
};

exports.lazyload = function (id, classImg) {
    var listwrap = document.getElementById(id);
    if (listwrap) {
        var teamLogo = document.getElementsByClassName(classImg);
        var windowH = window.innerHeight;
        var offsetY = window.pageYOffset;
        for (var i = 0; i < teamLogo.length; i++) {
            var iT = teamLogo[i].getBoundingClientRect().top;
            if (iT < windowH + offsetY + windowH * 3 / 4) {
                if (teamLogo[i].getAttribute('data-src')) {
                    teamLogo[i].src = teamLogo[i].getAttribute('data-src');
                    teamLogo[i].removeAttribute('data-src');
                }
            }
        }
    }
};

exports.timeForInOut = function () {};

exports.checkOperamini = function () {
    var isOperaMini = navigator.userAgent.indexOf('Opera Mini') > -1;
    return isOperaMini;
};

exports.record = function (url) {
    var prefix = '//stat.allfootballapp.com';
    var newImage = new Image();
    newImage.src = prefix + '/' + url;
    return newImage;
};

exports.getQueryString = function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
};

/***/ }),

/***/ 857:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(858);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("85598e4a", content, true, {});

/***/ }),

/***/ 858:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(498);
exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "body,html{height:100%;background-color:#262a34;padding:0;margin:0}.download-coin-wrap{width:100%;height:41.6rem;background:url(" + escape(__webpack_require__(859)) + ") no-repeat;background-size:100%;position:absolute;top:0;bottom:0;margin:auto;text-align:center;color:#fff}.download-coin-wrap header{padding-top:9.06rem}.download-coin-wrap header img{width:4.25rem;margin-bottom:2.125rem}.download-coin-wrap header h1{font-size:2rem;font-weight:700;line-height:1;margin:0}.download-coin-wrap header p{font-size:.75rem}.download-coin-wrap section{padding-top:3.56rem}.download-coin-wrap section .btn{display:block;width:12.375rem;height:2.5rem;line-height:2.5rem;font-size:1.15rem;color:#fff;background:#16ac3a;margin:2.75rem auto 1rem;border-radius:2px;font-weight:700}.download-coin-wrap section .icon-download{background:url(" + escape(__webpack_require__(860)) + ") no-repeat;background-size:100%;display:inline-block;width:.8rem;height:.8rem}.download-coin-wrap section .invite-code{display:block;width:12.5rem;height:2.375rem;background:#1c1d22;margin:0 auto 1.2rem;border-radius:4px;line-height:2.375rem;font-size:1.1rem;font-weight:700;text-align:center;white-space:nowrap}.download-coin-wrap section .invite-code input{border:none;background:none;font-size:1.1rem;color:#b5bcc4;width:6.5rem;text-align:center;font-weight:700}.download-coin-wrap section .invite-code .copy{color:#16ac3a;border-left:1px solid #292c34;padding-left:.5em;font-size:.75em}.download-coin-wrap section .invite-code .icon-copy{width:1rem;height:1rem;display:inline-block;background:url(" + escape(__webpack_require__(861)) + ") no-repeat;background-size:100%;vertical-align:middle}.download-coin-wrap section p{width:80%;margin:0 auto;color:#b5bcc4;font-size:.9rem}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/pages/AppDownloadCoin.vue"],"names":[],"mappings":"AACA,UAEE,YAAa,AACb,yBAA0B,AAC1B,UAAW,AACX,QAAU,CACX,AACD,oBACE,WAAY,AACZ,eAAgB,AAChB,mDAA0D,AAC1D,qBAAsB,AACtB,kBAAmB,AACnB,MAAO,AACP,SAAU,AACV,YAAa,AACb,kBAAmB,AACnB,UAAY,CACb,AACD,2BACE,mBAAqB,CACtB,AACD,+BACE,cAAe,AACf,sBAAwB,CACzB,AACD,8BACE,eAAgB,AAChB,gBAAkB,AAClB,cAAe,AACf,QAAU,CACX,AACD,6BACE,gBAAmB,CACpB,AACD,4BACE,mBAAqB,CACtB,AACD,iCACE,cAAe,AACf,gBAAiB,AACjB,cAAe,AACf,mBAAoB,AACpB,kBAAmB,AACnB,WAAY,AACZ,mBAAoB,AACpB,yBAA0B,AAC1B,kBAAmB,AACnB,eAAkB,CACnB,AACD,2CACE,mDAA4D,AAC5D,qBAAsB,AACtB,qBAAsB,AACtB,YAAa,AACb,YAAc,CACf,AACD,yCACE,cAAe,AACf,cAAe,AACf,gBAAiB,AACjB,mBAAoB,AACpB,qBAAsB,AACtB,kBAAmB,AACnB,qBAAsB,AACtB,iBAAkB,AAClB,gBAAkB,AAClB,kBAAmB,AACnB,kBAAoB,CACrB,AACD,+CACE,YAAa,AACb,gBAAiB,AACjB,iBAAkB,AAClB,cAAe,AACf,aAAc,AACd,kBAAmB,AACnB,eAAkB,CACnB,AACD,+CACE,cAAe,AACf,8BAA+B,AAC/B,kBAAoB,AACpB,eAAkB,CACnB,AACD,oDACE,WAAY,AACZ,YAAa,AACb,qBAAsB,AACtB,mDAA4D,AAC5D,qBAAsB,AACtB,qBAAuB,CACxB,AACD,8BACE,UAAW,AACX,cAAe,AACf,cAAe,AACf,eAAkB,CACnB","file":"AppDownloadCoin.vue","sourcesContent":["\nhtml,\nbody {\n  height: 100%;\n  background-color: #262a34;\n  padding: 0;\n  margin: 0;\n}\n.download-coin-wrap {\n  width: 100%;\n  height: 41.6rem;\n  background: url(../assets/download-coin-bg.jpg) no-repeat;\n  background-size: 100%;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  text-align: center;\n  color: #fff;\n}\n.download-coin-wrap header {\n  padding-top: 9.06rem;\n}\n.download-coin-wrap header img {\n  width: 4.25rem;\n  margin-bottom: 2.125rem;\n}\n.download-coin-wrap header h1 {\n  font-size: 2rem;\n  font-weight: bold;\n  line-height: 1;\n  margin: 0;\n}\n.download-coin-wrap header p {\n  font-size: 0.75rem;\n}\n.download-coin-wrap section {\n  padding-top: 3.56rem;\n}\n.download-coin-wrap section .btn {\n  display: block;\n  width: 12.375rem;\n  height: 2.5rem;\n  line-height: 2.5rem;\n  font-size: 1.15rem;\n  color: #fff;\n  background: #16ac3a;\n  margin: 2.75rem auto 1rem;\n  border-radius: 2px;\n  font-weight: bold;\n}\n.download-coin-wrap section .icon-download {\n  background: url(../assets/download-coin-icon.png) no-repeat;\n  background-size: 100%;\n  display: inline-block;\n  width: .8rem;\n  height: .8rem;\n}\n.download-coin-wrap section .invite-code {\n  display: block;\n  width: 12.5rem;\n  height: 2.375rem;\n  background: #1c1d22;\n  margin: 0 auto 1.2rem;\n  border-radius: 4px;\n  line-height: 2.375rem;\n  font-size: 1.1rem;\n  font-weight: bold;\n  text-align: center;\n  white-space: nowrap;\n}\n.download-coin-wrap section .invite-code input {\n  border: none;\n  background: none;\n  font-size: 1.1rem;\n  color: #b5bcc4;\n  width: 6.5rem;\n  text-align: center;\n  font-weight: bold;\n}\n.download-coin-wrap section .invite-code .copy {\n  color: #16ac3a;\n  border-left: 1px solid #292c34;\n  padding-left: 0.5em;\n  font-size: 0.75em;\n}\n.download-coin-wrap section .invite-code .icon-copy {\n  width: 1rem;\n  height: 1rem;\n  display: inline-block;\n  background: url(../assets/download-coin-copy.png) no-repeat;\n  background-size: 100%;\n  vertical-align: middle;\n}\n.download-coin-wrap section p {\n  width: 80%;\n  margin: 0 auto;\n  color: #b5bcc4;\n  font-size: 0.9rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 859:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/download-coin-bg.2f97c59.jpg";

/***/ }),

/***/ 860:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAArCAMAAAA5QerMAAAAflBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////vroaSAAAAKXRSTlMA9NNeA8LImQbndljkxWIo4BrvJfnMZx0VtK4NCNmmnTwwELqPh35vTfs1P1sAAAFHSURBVDjLnZXZbsIwEEWv6yUxkJ19h67z/z9YpanqeGqiEUfiAesQHM+dMZ5nozPrFSlvM91MeHlpaYzVeVo06wVxFqVJmNWKUrgOnLmiNGrOzBk9ZsZNoTunacIeKrbPpWMLqsKAcRTzhW4ZrxQYWBPDAC9sqRxqVHMV/9U679WSBCrpXnUi1fZZIpFKDaCFqgYyoZoBhVAtAC9UF4AKX/YtU5e78BMFhMpv0dWRqq7IT+G/wlNbA2zqkdpeARSjp/rxO6I5/antDcBn2F50AhcDbF9+VX+LI1/E53ru3dWP6isAH+NzZdXa58DdAdh1AN6javEM7I7AAcPnjWWAJ+v1iAFWcZvIqz2gx1xYWlJd4O69eeZdkOyt1RbHPe+tBx3bOs9jFc2BKVT1xHQRziz5JJTPV/nUlt8FnFxP3TCcht1bz/ENsFuz2T5JLD0AAAAASUVORK5CYII="

/***/ }),

/***/ 861:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAMAAAC7faEHAAAAUVBMVEUAAAAWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsTruOliHAAAAGnRSTlMAcGBQIPnSgATFmZJrDunZrIuEZLx3ylhBOuVQkXEAAAC9SURBVDjL7dS5DsMgEEXRMQQwxvuS5f3/h8amIFOMwV0UKVdyYekwBdJALHU3EDJeE6/BaRNjCzKxiQNgJiUUDOAT6wA4EguAST+3OF2sAvBFt1iD/lV0I47GkmsRcyVnj+utdF1y+zfT3gVX/d3vusweNYCJLu1lqIR2Bv9xCpl0dMV3Yybm6OHld2jVlFy+vAt2ueKegOkuOA3gxt0ssrixaV7cS6eEth7o+alMjlL1eM7WmhhsrayGjbE3Ceoyyd7//FsAAAAASUVORK5CYII="

/***/ }),

/***/ 862:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var utilObj = __webpack_require__(499);

exports.default = {
    data: function data() {
        return {
            inviteCode: this.$route.query.invite_code,
            isAndroid: true
        };
    },
    head: function head() {
        var title = this.$t('shareForCoin');
        var HOST =  true ? 'https://m-yinni.allsepakbola.net' : 'https://beta-m-yinni.allfootballapp.com';
        var shareUrl = HOST + this.$route.fullPath;
        return {
            title: title,
            meta: [{ name: 'twitter:card', content: 'summary_large_image' }, { name: 'twitter:site', content: '@allfootballapp' }, { name: 'twitter:creator', content: '@allfootballapp' }, { name: 'twitter:app:id:ipad', content: '' }, { name: 'twitter:title', content: title }, { name: 'twitter:image', content: 'https://allfootball-static.dongqiudi.com/n/public/favicon.ico' }, { name: 'fb:app_id', content: 'summary_large_image' }, { name: 'og:url', content: shareUrl }, { name: 'og:type', content: 'article' }, { name: 'og:title', content: title }, { name: 'og:description', content: title }, { name: 'og:image', content: 'https://allfootball-static.dongqiudi.com/n/public/favicon.ico' }, { name: 'og:site_name', content: 'AllfootballOfficial' }]
        };
    },
    created: function created() {},
    mounted: function mounted() {
        var browser = utilObj.detectUa();
        this.isAndroid = browser.isAndroid;
        var vm = this;
        if (browser.isAndroid) {
            var referrer = encodeURIComponent('utm_source=share&utm_medium=app&utm_content=' + this.inviteCode + '&anid=admob');
            location.href = 'market://details?id=com.allfootball.news&referrer=' + referrer;

            var _start = new Date().getTime();

            setTimeout(function () {
                var _end = new Date().getTime();
                if (_end - _start < 800) {
                    vm.isAndroid = false;
                }
            }, 500);
        }
        if (window.history) {
            var fullPath = this.$route.fullPath;
            history.replaceState(null, 'share', '/home?utm_source=shareForAFCoin');
            history.pushState(null, 'share', fullPath);

            window.addEventListener('popstate', function (event) {
                if (location.pathname !== '/news') {
                    location.reload();
                }
            });
        }
    },

    methods: {
        copy: function copy() {
            var browser = utilObj.detectUa();
            var $input = this.$el.getElementsByClassName('invite-code-input');
            var el = $input && $input[0];
            if (!browser.isAndroid && el) {
                var editable = el.contentEditable;
                var readOnly = el.readOnly;
                el.contentEditable = true;
                el.readOnly = false;
                var range = document.createRange();
                range.selectNodeContents(el);
                var sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
                el.setSelectionRange(0, 999999);
                el.contentEditable = editable;
                el.readOnly = readOnly;
            } else if (el && el.select) {
                el.select();
            }

            try {
                document.execCommand('copy');
                el.blur();
                this.$toast(this.$t('copySuccess'));
            } catch (err) {
                console.log(err);
            }
        },
        copyAndDownload: function copyAndDownload() {
            this.copy();

            location.href = '/download?utm_source=shareForAFCoin';
        }
    }
};

/***/ }),

/***/ 863:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "download-coin-wrap"
  }, [_c('header', [_c('img', {
    attrs: {
      "src": __webpack_require__(864),
      "alt": "All Sepakbola"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("All Sepakbola")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.$t('bestApp')))])]), _vm._v(" "), (!_vm.isAndroid) ? _c('section', [_c('div', {
    staticClass: "invite-code"
  }, [_c('input', {
    staticClass: "invite-code-input",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.inviteCode
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "copy",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.copy()
      }
    }
  }, [_c('i', {
    staticClass: "icon-copy"
  }), _vm._v("  " + _vm._s(_vm.$t('copy')))])]), _vm._v(" "), _c('p', [_vm._v("* " + _vm._s(_vm.$t('downloadForCoin')))]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.copyAndDownload()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('download')) + " "), _c('i', {
    staticClass: "icon-download"
  })])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 864:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/download-coin-logo.0f57fff.png";

/***/ })

});


// WEBPACK FOOTER //
// static/js/12.ebd1c0984a6ca270c111.js